function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { _camelToColonSeparated } from "./lib/_camelToColonSeparated";
if (typeof global !== "undefined") {
    global.CustomEvent = global.CustomEvent || class CustomEvent1 {
        constructor(){
            throw Error("In Node.js, only class declarations are supported, and instance creation is not supported.");
        }
    };
}
export class CustomEventWithoutDetail extends CustomEvent {
    static toString() {
        return _camelToColonSeparated(this.name);
    }
}
export class CustomEventOptionalDetail extends CustomEvent {
}
export class CustomEventWithDetail extends CustomEvent {
    static toString() {
        return _camelToColonSeparated(this.name);
    }
    constructor(eventType, eventInitDict){
        super(eventType, eventInitDict);
        _define_property(this, "isCustomEventWithDetail", true);
    }
}
